import React from 'react'
import CustomScrollbar from 'js/common/components/CustomScrollbar';
import { getI18NMessageString } from 'I18N/I18NHelper';
import AppHelper from 'js/app/AppHelper';
import { GLOBAL_CONSTANTS } from 'js/common/constants/GlobalConstants';
import AppUtil from 'js/utils/AppUtil';

function EWRHelpPage(){
    
    const isSourceSwiftEnterprise = AppHelper.getAppData('enterpriseType') === GLOBAL_CONSTANTS.SWIFTENTERPRISE;
    return (
        <div className="no-data-page-container">
        <CustomScrollbar style={{ height: '100%', width: '32%' }} className="data-container">
            <div className="part-one">
            There are times when you want to track work requests coming from users who may not be part of your system. 
            It could be some feedback, a ticket, a bug or simply something that needs to be added in your work tracker on an adhoc basis so that you don't lose track of it. 
            Generally, this requires some sort of integration or a manual process of collating such requests in Excel and importing them.
            </div>
            <div className="part-two">
            Well, we have cut short all these steps with our External Work Requests feature. 
            This feature helps you configure a new form and embed it as a link in your website page. 
            When the user submits the form after filling the details, a workitem gets created in the application with those details.
            <br></br>
            <br></br>
            Learn more about using the External Work Requests using these links:
            </div>
            <div className="part-three">
            {
                isSourceSwiftEnterprise ?
                (
                    <ul className="rule-page-types">
                    <li className="rule-page-type">
                        <a target="_blank" rel="noopener noreferrer" href={AppHelper.getAppData("helpURL")+'#Creating_External_Work_Requests'}>How to create an External Work Request?</a>
                    </li>
                    <li className="rule-page-type">
                        <a target="_blank" rel="noopener noreferrer" href={AppHelper.getAppData("helpURL")+'#Embedding_an_External_Work_Requests_into_your_Website'}>How to embed an External Work Request into your website?</a>
                    </li>
                    <li className="rule-page-type">
                        <a target="_blank" rel="noopener noreferrer" href={AppHelper.getAppData("helpURL")+'#Viewing_the_External_Work_Request_Form_in_a_Website'}>How to view the External Work Request Form in a website?</a>
                    </li>
                    <li className="rule-page-type">
                        <a target="_blank" rel="noopener noreferrer" href={AppHelper.getAppData("helpURL")+'#Creating_Work_Requests_directly_from_MS_Outlook_Application'}>How to create work request directly from MS Outlook application?</a>
                    </li>
                </ul>
                 )
                :
                <ul className="rule-page-types">
                <li className="rule-page-type">
                    <a target="_blank" rel="noopener noreferrer" href={getI18NMessageString('linkForSK1')}>How to create an External Work Request?</a>
                </li>
                <li className="rule-page-type">
                    <a target="_blank" rel="noopener noreferrer" href={getI18NMessageString('linkForSK2')}>How to embed an External Work Request into your website?</a>
                </li>
                <li className="rule-page-type">
                    <a target="_blank" rel="noopener noreferrer" href={getI18NMessageString('linkForSK3')}>How to view the External Work Request Form in a website?</a>
                </li>
                <li className="rule-page-type">
                    <a target="_blank" rel="noopener noreferrer" href={getI18NMessageString('linkForSK4')}>How to create work request directly from MS Outlook application?</a>
                </li>
            </ul>
                
            }
            </div> 
            </CustomScrollbar>
            <div className="gif-container">
                <img className='rule-gif-div' src={ AppUtil.processURLForAppContextPath('images/ewrhelp.gif') }
                alt="Business rule help"></img>
            </div>
            </div>
    )
}
export default EWRHelpPage
